<div #ankRef style="display: inline" [ngClass]="className">
  <ng-content></ng-content>
</div>